module.exports = __webpack_public_path__ + "static/alcaldia-de-bogotá-ff47a0face6bdc3f3197d03a24104aad.png";